<template>
  <picker-field :label="label" :value="value" ref="picker" @open="onSearch">
    <div class="list">
      <div class="weui-cells">
        <div
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          @click="select(item)"
        >
          <div class="weui-cell__bd">
            <p>{{ item.fcs_itemname }}</p>
          </div>
          <div class="weui-cell__ft"></div>
        </div>
      </div>
    </div>
  </picker-field>
</template>

<script>
import PickerField from "@/components/field/PickerField.vue";

export default {
  components: {
    PickerField,
  },
  props: {
    label: {
      type: String,
      default: "费用类型",
    },
    value: String,
  },
  data() {
    return {
      items: [],
    };
  },
  methods: {
    select(item) {
      var me = this;
      me.$emit("input", item.fcs_itemname);
      me.$emit("select", item);
      me.$refs.picker.close();
    },
    onSearch() {
      var me = this;
      me.$loading({
        url: "/api/money/feecategory/list/current",
      }).then(function (res) {
        if (res.success) {
          if (!res.data || !res.data.length) {
            me.$weui.topTips("请先设置您所在部门的费用报销科目", 2000);
          } else {
            me.items = res.data;
          }
        } else {
          me.$weui.topTips(res.message, 2000);
        }
      });
    },
  },
};
</script>